import { FaTrash, FaRegTimesCircle } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import L from 'leaflet';
import '../styles/global.css';
import { useEffect, useRef, useState } from 'react';
import API from '../api/API';
import { carregarZipFromURL, createMapOnBahia, popUpForPropriedade } from '../utils/mapas';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import CustomToolbar from './components/CustomToolbar';
import { Toast } from 'primereact/toast';
import { message } from '../utils/messages';
import * as mapas from '../utils/mapas'
import { LoteType } from '../db/Orm';
import { Dock } from 'primereact/dock';
import { MenuItem } from 'primereact/menuitem';
import { ReactComponent as BackIcon } from '../images/back.svg';
import { ReactComponent as ListIcon } from '../images/book-library-svgrepo-com.svg';
import { ReactComponent as TelescopeIcon } from '../images/telescope-svgrepo-com.svg';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressBar } from 'primereact/progressbar';
import { Calendar } from 'primereact/calendar';
import { AxiosError } from 'axios';
import { Tooltip } from 'primereact/tooltip';
import Auth from '../auth/Authenticator';

function Propriedade() {
    const mapRef = useRef<any>(null);
    const auth = Auth.useAuth();
    // const [user, propriedade, municipios] = useLocation().state as any;
    const [propriedade, municipio] = useLocation().state as any;
    const navigator = useNavigate();
    const [mapa, setMapa] = useState<L.Map>();
    const toast = useRef<Toast | null>(null)
    
    useEffect(() => {
        try {
            !mapa && setMapa(createMapOnBahia(mapRef))
        } catch (e: any) {
            console.log('error:', e)
        }
    }, []);

    const [loading, setLoading] = useState(false)

    const loadFazenda = async () => {
        if (mapa) {
            if (propriedade.poligono) {
                const poligonos = await carregarZipFromURL(propriedade.poligono, mapas.estiloContorno)
                poligonos.eachLayer(poligono => {
                    if (poligono instanceof L.FeatureGroup) {
                        poligono.bindPopup(popUpForPropriedade(propriedade, poligono))
                        mapa.addLayer(poligono);
                        poligono.openPopup()
                    }
                    mapa.flyToBounds(poligonos.getBounds())
                })
            }
            propriedade.lotes?.map(async (lote: LoteType) => {
                const polygon = await carregarZipFromURL(lote.poligono, mapas.estiloArea)
                mapa.addLayer(polygon)
            })
        }
    }
    useEffect(() => {
        loadFazenda()
    }, [mapa]);

    const confirmRemove = () => {
        if (!auth.hasPermission('monitorabahia.delete_propriedade')){
            toast.current?.show({severity:'error', summary: 'Permissões Insuficientes', detail:'Você não possui permissão para remover propriedade.'})
            return
        }
        confirmDialog({
            message: 'Você tem certeza que deseja remover a propriedade ' + propriedade.nome + '?',
            header: 'Cadastro de Propriedade',
            icon: 'pi pi-exclamation-triangle',
            accept,
            reject
        });
    }

    const accept = async () => {
        const mensagemSucesso = () => {
            message(toast.current, 'Propriedade ' + propriedade.nome + ' identificada por ' + propriedade.id + ' foi removida com sucesso!')
        }
        await API.removePropriedade(propriedade, mensagemSucesso)
    }

    const reject = () => {
    }

    const [dialogVisivel, setDialogVisivel] = useState(false);
    const [progresso, setProgresso] = useState(0);
    const [mensagemLoading, setMensagemLoading] = useState('');
    const [apiConcluida, setApiConcluida] = useState(false); // Controla se a chamada da API (sucesso/erro) terminou
    const toastRef = useRef<any>(null);
    const [dialogProcessarVisivel, setDialogProcessarVisivel] = useState(false)
    const [dialogCheckVisivel, setDialogCheckVisivel] = useState<boolean>(false)
    const [mensagemCheck, setMensagemCheck] = useState<string>('')
    // const [dataInicio, setDataInicio] = useState<Nullable<Date>>(null)
    // const [dataFinal, setDataFinal] = useState<Nullable<Date>>(null)
    const [erroProcessar, setErroProcessar] = useState<Boolean>(false)

    const intervaloProgressoRef = useRef<any>(null);
    const inicioTimerRef = useRef<any>(null);
    const filenameRef = useRef<string>()
    const CINCO_MINUTOS_MS = 2 * 60 * 1000;

    // Limpa o intervalo quando o componente é desmontado
    useEffect(() => {
        return () => {
            if (intervaloProgressoRef.current) {
                clearInterval(intervaloProgressoRef.current);
            }
        };
    }, []);

    const processar = async (force?: boolean) => {
        if (!dates[0] || !dates[1]) return
        setDialogProcessarVisivel(false)
        setErroProcessar(false)
        setDialogVisivel(true);
        setProgresso(0);
        setApiConcluida(false);
        setMensagemLoading('Iniciando processamento do relatório...');
        inicioTimerRef.current = Date.now();

        // Limpa qualquer intervalo anterior
        if (intervaloProgressoRef.current) {
            clearInterval(intervaloProgressoRef.current);
        }

        // Configura o intervalo para a barra de progresso atingir 100% em 5 minutos
        intervaloProgressoRef.current = setInterval(() => {
            const tempoDecorrido = Date.now() - inicioTimerRef.current;
            const progressoAtual = Math.round(Math.min(100, (tempoDecorrido / CINCO_MINUTOS_MS) * 100));
            setProgresso(progressoAtual);

            if (progressoAtual >= 100) {
                clearInterval(intervaloProgressoRef.current);
                intervaloProgressoRef.current = null;
                // Se a API ainda não terminou, a mensagem pode mudar
                if (!apiConcluida) {
                    setMensagemLoading('O processamento está quase lá. Apenas mais alguns instantes...');
                }
            }
        }, 200); // Atualiza a cada 200ms para uma animação suave

        try {
            // Chamada real da API
            const response = await API.processarPropriedade(propriedade.id, dates[0], dates[1], force?undefined:'check');
            if ('toJSON' in response) { //Ocorreu erro
                throw response
            }
            setApiConcluida(true); // API terminou (com sucesso)

            if (intervaloProgressoRef.current) { // Para o timer da barra de progresso se ainda estiver rodando
                clearInterval(intervaloProgressoRef.current);
                intervaloProgressoRef.current = null;
            }
            setProgresso(100); // Garante que a barra está em 100%
            setMensagemLoading('Relatório processado com sucesso! Preparando para download...');

            // Lógica de download do arquivo (adaptada da sua implementação anterior)
            if (response !== null) {
                const blob = response.data as Blob;
                let filename = `relatorio_${propriedade.nome || propriedade.id}.pdf`; // Nome de fallback
                const contentDisposition = response.headers['content-disposition'];
                console.log('response.headers', response.headers)
                if (contentDisposition) { //PDF foi gerado
                    const filenameMatch = contentDisposition.match(/filename="?(.+?)"?(;|$)/i);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1];
                    }
                    downloadBlobResponse(blob, filename)
                } else {
                    const data = JSON.parse(await blob.text())
                    setMensagemCheck(data.detail)
                    setDialogCheckVisivel(true)
                    filenameRef.current = data.filename
                }
                setTimeout(() => setDialogVisivel(false), 1500); // Fecha o diálogo após um tempo
            }

        } catch (error: any) {
            const axiosErr = error as AxiosError
            const blobResp = axiosErr.response?.data as Blob
            const jsonResp = blobResp ? JSON.parse(await blobResp.text()) : null
            setApiConcluida(true); // API terminou (com erro)
            if (intervaloProgressoRef.current) {
                clearInterval(intervaloProgressoRef.current);
                intervaloProgressoRef.current = null;
            }
            console.error('Erro ao processar relatório:', error);
            jsonResp && console.error(jsonResp)
            setErroProcessar(true)
            let mensagemErroApi = 'Falha ao processar o relatório: ';
            mensagemErroApi += error.message ? error.message : 'Não foi possível ler a mensagem de erro do servidor.'
            jsonResp && (mensagemErroApi += (mensagemErroApi.endsWith('.') || '. ') + jsonResp.detail)
            console.log(mensagemErroApi)
            setMensagemLoading(mensagemErroApi)
            setDialogVisivel(false)
            toastRef.current.show({ severity: 'error', summary: 'Erro no Processamento', detail: mensagemErroApi, life: 6000 });
        }
    };
    const downloadBlobResponse = (blob: Blob, filename:string)=>{
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        toastRef.current.show({ severity: 'success', summary: 'Sucesso', detail: `Download do '${filename}' iniciado.`, life: 4000 });
    }
    const baixarDoc = async (filename: string, mode?: string)=>{
        try {
            const response = await API.processarPropriedade(propriedade.id, dates[0], dates[1], mode);
            if ('toJSON' in response) { //Ocorreu erro
                throw response
            }
            downloadBlobResponse(response.data, filename)
        } catch (error) {
            console.error(error)
        }
    }
    const onHideDialog = () => {
        setDialogVisivel(false);
        // Resetar estados para a próxima vez, se necessário,
        // especialmente se o usuário puder fechar manualmente (o que não é o caso aqui durante o processamento)
        if (apiConcluida) {
            setProgresso(0);
            setMensagemLoading('');
        }
    };

    const [showInfo, setShowInfo] = useState<boolean>(false)
    const InfoMenu = {
        label: 'Pesquisar',
        icon: () => <ListIcon />,
        command: () => { setShowInfo(true) }
    }
    const ProcessarMenu = {
        label: 'Processar',
        icon: <TelescopeIcon />,
        command: () => { setDialogProcessarVisivel(true) }
    }
    const VoltarMenu = {
        label: 'Voltar',
        icon: () => <BackIcon />,
        command: () => {
            console.log('Fazenda', propriedade)
            navigator('/municipio', { state: [municipio] })
        }
    }
    const items: MenuItem[] = (() => {
        if (!auth.user) return [VoltarMenu]
        // switch (global.user.groups[0].id) {
        //     case 2:
        //         return [InfoMenu, ProcessarMenu, VoltarMenu]
        //     case 1:
        //         return [InfoMenu, ProcessarMenu, VoltarMenu]
        //     default:
        //         return [InfoMenu, VoltarMenu]
        // }
        const options = []
        if (auth.hasPermission('monitorabahia.propriedades_info')) options.push(InfoMenu)
        if (auth.hasPermission('monitorabahia.propriedades_processar')) options.push(ProcessarMenu)
        options.push(VoltarMenu)
        return options
    })()

    const dialogFooter = apiConcluida ? (
        <Button label="Fechar" icon="pi pi-check" onClick={onHideDialog} autoFocus />
    ) : null;
    const [dates, setDates] = useState<Date[]>([])
    const minDate = new Date()
    minDate.setFullYear(minDate.getFullYear() - 5)
    const maxDate = new Date()
    const handleUpdateDates = (e: any) => {
        const dates: (Date | null)[] = e.value
        setDates(dates.filter(d => d !== null) as Date[])
    }
    const checkClickOptions = {
        reprocessar: ()=>{
            setDialogCheckVisivel(false)
            setTimeout(()=>processar(true), 500)
        },
        baixar: ()=>{
            const filename = filenameRef.current
            if (!filename) return
            setDialogCheckVisivel(false)
            baixarDoc(filename, 'get')
        }
    }
    const dialogProcessar = <Dialog onHide={() => { setDialogProcessarVisivel(false) }}
        visible={dialogProcessarVisivel} header={<div style={{ display: 'flex', alignItems: 'center' }}><TelescopeIcon width={32} style={{ marginRight: 10 }} />PROCESSAR PROPRIEDADE</div>}>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'left'}}>
            <label style={{marginLeft:15}}>Período</label>
            <Calendar style={{ marginLeft: 10, width: 850 }}
                dateFormat='dd/mm/yy' onChange={handleUpdateDates} value={dates}
                // showIcon 
                minDate={minDate} maxDate={maxDate} 
                selectionMode="range" readOnlyInput hideOnRangeSelection numberOfMonths={2} inline />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
            <Button onClick={()=>processar()}>INICIAR</Button>
        </div>
    </Dialog>
    const dialogCheck = <Dialog visible={dialogCheckVisivel} onHide={()=>setDialogCheckVisivel(false)}
    header={'AVISO'} className='check-dialog' closable={false}>
        <p>{mensagemCheck}</p>
        <p>Como deseja proseguir?</p>
        <div>
            <Button onClick={checkClickOptions.reprocessar} severity='warning'>REPROCESSAR</Button>
            <Button onClick={checkClickOptions.baixar}>BAIXAR</Button>
            <Button severity='secondary' onClick={()=>setDialogCheckVisivel(false)}>SAIR</Button>
        </div>
    </Dialog>
    return (
        <div className='Info'>
            <Toast ref={toast} position='center' />
            <Toast ref={toastRef} />
            <Dialog
                header="Processando Relatório"
                visible={dialogVisivel}
                modal
                style={{ width: '50vw', minWidth: '350px' }}
                onHide={onHideDialog} // Chamado ao tentar fechar (ex: ESC, botão X se `closable` fosse true)
                closable={apiConcluida} // Só permite fechar após a API concluir (sucesso/erro)
                footer={dialogFooter}
            >
                <div className="p-fluid" style={{ padding: '1rem 0' }}>
                    <p style={{ marginBottom: '1rem', textAlign: 'center' }}>{mensagemLoading}</p>
                    {!erroProcessar &&
                        <ProgressBar
                            // value={progresso} 
                            // showValue={true} 
                            mode="indeterminate"
                            style={{ height: '20px' }} />
                    }
                    {erroProcessar && <div style={{ textAlign: 'center' }}>
                        <FaRegTimesCircle size={50} color='#D22' />
                    </div>}
                    {!apiConcluida && progresso >= 99 && progresso < 100 && (
                        <p style={{ marginTop: '1rem', textAlign: 'center', fontSize: '0.9em', color: '#6c757d' }}>
                            Quase lá! Finalizando os últimos detalhes...
                        </p>
                    )}
                </div>
            </Dialog>
            {dialogProcessar}
            {dialogCheck}
            <ConfirmDialog />
            <CustomToolbar user={auth.user} titulo={propriedade.nome?.toUpperCase()} loading={loading} />

            <Dialog header={`Propriedade ${propriedade.nome}`} visible={showInfo} modal={false} style={{ width: '50vw' }} onHide={() => setShowInfo(false)}>

                <div style={{ display: 'flex', flexDirection: 'column' }}>

                    <label htmlFor='municipio'>MUNICÍPIO</label>
                    <InputText id='municipio' value={propriedade.municipio?.nome ? propriedade.municipio.nome : municipio.nome.toUpperCase()} disabled style={{ marginBottom: 10 }} />

                    <label htmlFor='localidade'>LOCALIDADE</label>
                    <InputText id='localidade' value={propriedade.localidade?.toUpperCase()} disabled style={{ marginBottom: 10 }} />

                    <label htmlFor='acesso'>ACESSO</label>
                    <InputText id='acesso' value={propriedade.acesso?.toUpperCase()} disabled style={{ marginBottom: 10 }} />

                    <label htmlFor='proprietario'>PROPRIETÁRIO</label>
                    <InputText id='proprietario' value={propriedade.proprietario && propriedade.proprietario.pessoas_user?.length > 0 && propriedade.proprietario.pessoas_user[0].nome_razao.toUpperCase()} disabled style={{ marginBottom: 10 }} />

                    <label htmlFor='doc_matricula'>DOCUMENTO DE MATRÍCULA</label>
                    {propriedade.doc_matricula ? (
                        <Button icon="pi pi-file-pdf" label="Abrir Documento" onClick={() => window.open(propriedade.doc_matricula)} style={{ marginBottom: 10 }} />
                    ) : (
                        <InputText value="N/A" disabled style={{ marginBottom: 10 }} />
                    )}

                    <Button severity='danger' style={{ marginTop: 10, width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }} onClick={e => confirmRemove()}><FaTrash style={{ marginRight: 5 }} />REMOVER</Button>
                </div>

            </Dialog>


            <div id='map' ref={mapRef} style={{ zIndex: -1 }} />
            <Tooltip className="dark-tooltip" target=".dock-window .p-dock-action" my="center bottom-15" at="center top" showDelay={150} />
            <div className="dock-window" style={{ zIndex: 1 }}>
                <Dock model={items} position={'bottom'} />
            </div>
        </div >
    );
}


export default Propriedade;